// components/elements/swipers/CollectionsSwiper.tsx
"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { reviveSwiperOnResize } from "@/app/utils/swiperResize";
import SwiperButton from "../buttons/SwiperButton";
import CollectionCard from "../cards/collectionCard/CollectionCard";
import { Collection } from "@/app/lib/features/collection/collection.types";
interface CollectionsSwiperProps {
  collections: Collection[];
}

const CollectionsSwiper = ({ collections }: CollectionsSwiperProps) => {
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(true);

  const updateGradients = (swiper: SwiperType): void => {
    setShowLeftGradient(!swiper.isBeginning);
    setShowRightGradient(!swiper.isEnd);
  };

  if (!collections || collections.length === 0) return null;

  return (
    <Swiper
      className="relative"
      spaceBetween={8}
      slidesPerView={1.2}
      onSwiper={updateGradients}
      onSlideChange={updateGradients}
      watchSlidesProgress={false}
      updateOnWindowResize={false}
      // content-visibility ile ertelenen section'larda 0 genişlikte init olan
      // Swiper'ı kurtarır — bkz. swiperResize.ts
      onResize={reviveSwiperOnResize}
      breakpoints={{
        375: { slidesPerView: 1.4, spaceBetween: 8 },
        480: { slidesPerView: 1.6, spaceBetween: 10 },
        640: { slidesPerView: 2.0, spaceBetween: 10 },
        768: { slidesPerView: 2.3, spaceBetween: 12 },
        900: { slidesPerView: 2.6, spaceBetween: 12 },
        1024: { slidesPerView: 2.8, spaceBetween: 14 },
        1200: { slidesPerView: 3.1, spaceBetween: 14 },
        1400: { slidesPerView: 3.3, spaceBetween: 16 },
      }}
    >
      {collections.map((collection) => (
        <SwiperSlide key={collection.id}>
          <CollectionCard
            collection={collection}
          />
        </SwiperSlide>
      ))}
      <div className="absolute z-50 top-1/2 -translate-y-1/2 left-0 w-full items-center justify-between px-3 pointer-events-none hidden xl:flex">
        <SwiperButton position="left" slideMode="group" />
        <SwiperButton position="right" slideMode="group" />
      </div>
      <div
        className={`absolute top-0 left-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-r from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showLeftGradient ? "opacity-100" : "opacity-0"
        }`}
      />
      <div
        className={`absolute top-0 right-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-l from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showRightGradient ? "opacity-100" : "opacity-0"
        }`}
      />
    </Swiper>
  );
};

export default CollectionsSwiper;
